<template>
  <v-dialog v-model="showDialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Resetar senha</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-flex sm12
            ><label for="">Email: {{ user.email }}</label>
          </v-flex>
          <v-row sm12>
            <v-text-field
              v-model="data.password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              label="Nova Senha"
              counter
              @click:append="show1 = !show1"
            ></v-text-field>
          </v-row>
          <v-row sm8>
            <v-text-field
              v-model="data.confirmPassword"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show2 ? 'text' : 'password'"
              label="Confirmar Nova Senha"
              counter
              @click:append="show2 = !show2"
            ></v-text-field>
          </v-row>

          <v-row>
            <v-switch
              v-model="data.hasForPasswordChange"
              :label="`Solicitar nova senha no próximo login`"
            ></v-switch>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancelar">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="salvar">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show1: false,
      show2: false,
      data: {},
    };
  },
  props: {
    showDialog: Boolean,
    user: Object,
  },
  methods: {
    salvar() {
      this.$emit('salvar', this.data);
      this.data = {};
      this.show1 = false;
      this.show2 = false;
    },
    cancelar() {
      this.$emit('cancel');
      this.data = {};
      this.show1 = false;
      this.show2 = false;
    },
  },
};
</script>
